<template>
    <div>
        <v-treeview
            :items="items"
            item-text="name"
            item-children="children"
            activatable
            color="primary"
            :active.sync="active"
            :open.sync="open"
        >
            <template v-slot:label="{item}">
                <div style="display: flex; align-items: center; cursor: pointer;">
                    <v-icon v-if="item.is_private" size="16" style="padding-right: 0.3vw;">mdi-lock</v-icon>
                    <span style="font-family: Roboto; font-weight: 500; font-size: 14px; color: #565656;">{{ item.name=='Mi unidad'? $t('ViesValidator.my_unit'): item.name }}</span>
                </div>
            </template>
        </v-treeview>
    </div>
</template>
  
<script>
export default {
    name: 'FolderSelectorComponent',
    props: {
        value:{
            type: [String,Number],
            required: false,
            default: () => ('Mi unidad')
        },
        items: {
            type: Array,
            required: true
        },
        initial_selected_folder:{
            type: String,
            default: null
        }
    },

    data() {
        return {
            active: [],
            open: []
        }
    },
    methods:{
        conseole_print(e){
            console.log('test', e)
        },
        findPathToNode(items, targetId, path = []){
            for(const item of items){
                if (item.id === targetId) {
                    return [...path, item.id]
                }
                if(item.children && item.children.length) {
                    const result = this.findPathToNode(item.children, targetId, [...path, item.id])
                    if (result) return result;
                }
            }
            return null
        },
        setOpenAndActive(newVal){
            const path = this.findPathToNode(this.items, newVal)
            if(path){
                this.open = path.slice(0, -1)
                this.active = [newVal]
            }else{
                this.open = []
                this.active = []
            }
        }
    },
    computed:{

    },
    watch: {
        initial_selected_folder: {
            handler(newVal){
                this.setOpenAndActive(newVal)
            },
            immediate: true
        },
        active(newVal) {
            // console.log('testies', newVal[0])
            this.$emit('input', newVal[0]);
        },
        value(newVal) {
            this.setOpenAndActive(newVal);
        }
    },
    mounted(){

    }
}
</script>
  